import { useContext, useEffect } from "react";
import { Table } from "react-bootstrap";
import { isEmpty } from "lodash";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

import Breadcrumbs from "../../../utils/Breadcrumbs/Breadcrumbs";
import SiteTitle from "../../../utils/SiteTitle/SiteTitle";
import EmptyData from "../../../utils/EmptyData/EmptyData";
import CardLayout from "../../../utils/CardLayout/CardLayout";
import PaginationList from "../../../utils/PaginationList/PaginationList";
import CustomModal from "./../../../utils/CustomModal/CustomModal";
import TooltipTitle from "../../../utils/TooltipTitle/TooltipTitle";
import ItemInfo from "./../../../utils/ItemInfo/ItemInfo";
import { ConvertCurrency } from "../../../utils/Currency/Currency";
import { numberSeparate } from "../../../utils";
import { walletTransactionAdminContext } from "../../../context/Admin/WalletTransactionAdminContext/WalletTransactionAdminContext";
import { convertDate } from "../../../utils";

const WalletTransactionAdmin = () => {
  const { pathname } = useLocation();
  const permission = useSelector((state) => state.permission);

  const {
    transactions,
    transactionItem,
    search,
    setSearch,
    ordering,
    setOrdering,
    txType,
    setTxType,
    limit,
    setLimit,
    totalCount,
    pageNumber,
    setPageNumber,
    handleGetTransactions,
    handleGetTransactionDetails,
    handleCloseTransactionModal,
  } = useContext(walletTransactionAdminContext);

  useEffect(() => {
    handleGetTransactions();
  }, [pageNumber, limit, ordering, txType]);

  const onNavigate = (pk) => {
    window.open(
      `${pathname?.replace("WalletTransactions", "Orders")}/${pk}`,
      "_blank"
    );
  };

  const requestSort = (key) => {
    let direction = "";
    if (ordering.includes(key) && !ordering.includes("-")) direction = "-";
    setOrdering(`${direction}${key}`);
  };

  const sortIcon = (key) => {
    const isCurrent = ordering.includes(key);
    const direction = isCurrent
      ? ordering.includes("-")
        ? "desc"
        : "asc"
      : "";
    return (
      <span onClick={() => requestSort(key)} className="cursor-pointer">
        <i
          className={`fas fa-sort-amount-${
            direction === "asc"
              ? "up text-primary"
              : direction === "desc"
              ? "down text-primary"
              : "up"
          }`}
        />
      </span>
    );
  };

  const sortByOptions = [
    {
      label: "تاریخ ایجاد",
      options: [
        { title: "نزولی", value: "-created" },
        { title: "صعودی", value: "created" },
      ],
    },
    {
      label: "مبلغ",
      options: [
        { title: "نزولی", value: "-value" },
        { title: "صعودی", value: "value" },
      ],
    },
  ];

  return (
    <>
      <SiteTitle title="تراکنش‌های کیف پول" />
      <Breadcrumbs
        navs={[
          { name: "داشبورد", url: "/Admin/Dashboard", type: "l" },
          { name: "تراکنش‌های کیف پول", type: "a" },
        ]}
        title="لیست تراکنش‌های کیف پول"
      />

      <CardLayout>
        <form
          className="input-group mb-3"
          onSubmit={handleGetTransactions}
        >
          <input
            type="text"
            name="search"
            autoComplete="off"
            placeholder="جستجو در کد پیگیری، عنوان یا توضیحات..."
            className="form-control"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
          <div className="input-group-append">
            <button type="submit" className="btn btn-primary">
              جستجو
            </button>
          </div>
        </form>
        <div className="row">
          <div className="col-12 col-md-6 col-lg-3 mb-2">
            <TooltipTitle title="نوع تراکنش">
              <select
                className="form-control"
                name="txType"
                onChange={(e) => setTxType(e.target.value)}
                value={txType}
              >
                <option value="">نوع: همه</option>
                <option value="deposit">واریز (افزایش اعتبار)</option>
                <option value="withdraw">برداشت (کاهش اعتبار)</option>
              </select>
            </TooltipTitle>
          </div>
          <div className="col-12 col-md-6 col-lg-3 mb-2">
            <TooltipTitle title="مرتب سازی بر اساس">
              <select
                className="form-control"
                value={ordering}
                onChange={(e) => setOrdering(e.target.value)}
              >
                {sortByOptions.map((_item, index) => (
                  <optgroup label={_item.label} key={index}>
                    {_item.options?.map((option) => (
                      <option
                        key={option.value}
                        value={option.value}
                      >
                        {option.title}
                      </option>
                    ))}
                  </optgroup>
                ))}
              </select>
            </TooltipTitle>
          </div>
        </div>
        {isEmpty(transactions) ? (
          <EmptyData />
        ) : (
          <>
            <div className="d-flex justify-content-between align-items-center">
              <PaginationList
                setPageNumber={setPageNumber}
                pageCount={totalCount / limit}
              />
              <div>
                <select
                  className="form-control mb-3"
                  onChange={(e) => setLimit(Number(e.target.value))}
                  value={limit}
                >
                  <option value={10}>10</option>
                  <option value={25}>25</option>
                  <option value={50}>50</option>
                  <option value={75}>75</option>
                  <option value={100}>100</option>
                </select>
              </div>
            </div>
            <Table responsive hover borderless striped>
              <thead className="thead-dark text-center">
                <tr>
                  <th>#</th>
                  <th>نام و نام خانوادگی کاربر</th>
                  <th>شماره موبایل</th>
                  <th>عنوان / نوع</th>
                  <th>تاریخ ایجاد {sortIcon("created")}</th>
                  <th>مبلغ (ريال) {sortIcon("value")}</th>
                  <th>موجودی لحظه‌ای</th>
                  <th className="text-center">
                    تعداد کل :{" "}
                    <span className="badge badge-primary font-weight-bold p-1">
                      {totalCount}
                    </span>
                  </th>
                </tr>
              </thead>
              <tbody className="text-center">
                {transactions.map((_item, index) => {
                  const user = _item?.user_info;
                  const isDeposit = _item?.value > 0;
                  return (
                    <tr key={_item.id || index}>
                      <td>{index + 1}</td>
                      <td>
                        {user ? `${user.name || ""}` : "-"}
                      </td>
                      <td>{user?.mobile || "-"}</td>
                      <td>
                        <span className="badge badge-secondary">{_item?.title || _item?.transaction_type}</span>
                      </td>
                      <td>{convertDate(_item?.created)}</td>
                      <td>
                        <span className={`font-weight-bold text-${isDeposit ? "success" : "danger"}`}>
                          <ConvertCurrency price={Math.abs(_item?.value)} />
                          {isDeposit ? " (واریز)" : " (برداشت)"}
                        </span>
                      </td>
                      <td>
                        <ConvertCurrency price={_item?.running_balance} />
                      </td>
                      <td>
                        {_item?.order?.pk && (
                          <button
                            onClick={() => onNavigate(_item?.order?.pk)}
                            className="btn btn-primary mr-2"
                          >
                            سفارش
                          </button>
                        )}
                        <button
                          onClick={() => handleGetTransactionDetails(_item)}
                          className="btn btn-info mr-2"
                        >
                          جزئیات
                        </button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>
          </>
        )}
      </CardLayout>

      {/* Start Details Modal */}
      <CustomModal
        title="جزئیات تراکنش کیف پول"
        show={!isEmpty(transactionItem)}
        onHide={handleCloseTransactionModal}
        size="xl"
      >
        <div className="container">
          {transactionItem?.wallet?.user && (
            <div>
              <p className="text-info fw-bold text-center">کاربر</p>
              <div className="row">
                <ItemInfo label="نام و نام خانوادگی">
                  <p>
                    {transactionItem?.wallet?.user?.first_name}{" "}
                    {transactionItem?.wallet?.user?.last_name}
                  </p>
                </ItemInfo>
                <ItemInfo label="شماره موبایل">
                  <p>{transactionItem?.wallet?.user?.mobile}</p>
                </ItemInfo>
                <ItemInfo label="نام کاربری">
                  <p>{transactionItem?.wallet?.user?.username}</p>
                </ItemInfo>
              </div>
              <hr />
            </div>
          )}

          <div>
            <p className="text-info fw-bold text-center">اطلاعات تراکنش</p>
            <div className="row">
              <ItemInfo label="عنوان">
                <p>{transactionItem?.title || "-"}</p>
              </ItemInfo>
              <ItemInfo label="نوع تراکنش">
                <p>{transactionItem?.transaction_type || "-"}</p>
              </ItemInfo>
              <ItemInfo label="مبلغ تراکنش">
                <ConvertCurrency price={Math.abs(transactionItem?.value || 0)} />
              </ItemInfo>
              <ItemInfo label="موجودی پس از تراکنش">
                <ConvertCurrency price={transactionItem?.running_balance || 0} />
              </ItemInfo>
              <ItemInfo label="کد پیگیری / مرجع">
                <p>{transactionItem?.ref_code || "-"}</p>
              </ItemInfo>
              <ItemInfo label="ثبت‌کننده (پشتیبان/سیستم)">
                <p>
                  {transactionItem?.created_by
                    ? `${transactionItem.created_by.first_name || ""} ${transactionItem.created_by.last_name || ""}`
                    : "سیستم / خودکار"}
                </p>
              </ItemInfo>
              <ItemInfo label="تاریخ ایجاد">
                <p>{convertDate(transactionItem?.created)}</p>
              </ItemInfo>
              <ItemInfo label="توضیحات">
                <p>{transactionItem?.description || "-"}</p>
              </ItemInfo>
            </div>
            <hr />
          </div>

          {/* اگر تراکنش مرتبط با سفارش یا فاکتور باشد */}
          {transactionItem?.order && (
            <div>
              <p className="text-info fw-bold text-center">اطلاعات سفارش مرتبط</p>
              <div className="row">
                <ItemInfo label="شناسه سفارش">
                  <p>{transactionItem.order.id}</p>
                </ItemInfo>
                <ItemInfo label="کد پیگیری سفارش">
                  <p>{transactionItem.order.ref_num || "-"}</p>
                </ItemInfo>
              </div>
            </div>
          )}
        </div>
      </CustomModal>
      {/* End Details Modal */}
    </>
  );
};

export default WalletTransactionAdmin;